export default {"src":"/_next/static/media/checkmark-green.26984f64.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};